import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Case } from '../../../../../../../../../_base-shared/models/Case/Case';
import { CasePaymentStatusLog } from '../../../../../../../../../_base-shared/models/Case/CasePaymentStatusLog';
import { CaseService } from '../../../../case.service';

@Component({
  selector:    'app-case-payment-status-log',
  templateUrl: './case-payment-status-log.component.html',
  styles:      [],
})
export class CasePaymentStatusLogComponent implements OnInit, OnDestroy {
  @Input() case: Case;
  public isLoading                           = 0;
  public casePaymentStatusLogs: Array<CasePaymentStatusLog>;
  private subscriptions: Array<Subscription> = [];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private caseService: CaseService) {
  }

  ngOnInit(): void {
    this.fetchLogs(this.case.id);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private fetchLogs(caseId: number) {
    this.isLoading++;
    this.subscriptions.push(
        this.caseService.getPaymentStatusLogs(caseId, {all: 1}).pipe(finalize(() => this.isLoading--)).subscribe(
            result => this.casePaymentStatusLogs = result.data,
        ),
    );

  }

}
